
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 362.83 158.74"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#f37a1f","d":"M0 0h362.83v158.74H0z"}}),_c('path',{attrs:{"d":"M173.82 49.94h-54.83L114.6 64.3h18.38l-13.61 44.5h17.88l13.6-44.5h18.58l4.39-14.36zM55.39 59.08l-4.76 15.57c-2.12 6.93 1.74 12 8.57 12h22.29a1.45 1.45 0 011.33 1.91l-1.2 3.92a3 3 0 01-2.49 1.91h-35l-4.44 14.41h45.19c5 0 9.24-2.31 11.42-9.44l4.53-14.79c2.14-7-1.85-12-8.08-12h-22.4c-1.24 0-1.73-.9-1.39-2l1.2-3.92a3 3 0 012.91-2.31h32.24l4.39-14.36H66.92c-6.11-.04-9.92 3.87-11.53 9.1zm229.69 35.36l13.61-44.5h-17.98l-17.99 58.86h56.04l4.39-14.36h-38.07zm-33.72-44.5l-6.91 22.6h-21.39l6.91-22.6h-17.18L194.8 108.8h17.17l6.88-22.5h21.39l-6.87 22.5h17.64L269 49.94h-17.64zm-68.24 0l-17.99 58.86h17.98l17.99-58.86h-17.98z","fill":"#fff"}})])
          )
        }
      }
    